import { render } from "./DocsList.vue?vue&type=template&id=25247d4b"
import script from "./DocsList.vue?vue&type=script&lang=js"
export * from "./DocsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__